import WallpaperHomePage from "./campaign-flow/WallpaperHomePage";

/**
 * 國際版（香港 / 其他國家）入口：不走 LIFF、不做登入 / 綁定，直接進入桌布活動首頁。
 *
 * 連結：{base_url}/wallpaper/home（預設中文）、{base_url}/wallpaper/home?lang=en（英文）
 * 語系由外層 WallpaperProviders 依網址 ?lang 決定（無參數預設 zh-TW）。
 *
 * 目前與 LIFF 版共用同一個首頁畫面；若日後國際版要有差異
 * （例如分享改用網頁分享而非 LINE 分享），改這一層即可，不影響 LIFF 版。
 */
export default function WallpaperIntlPage() {
	return <WallpaperHomePage />;
}
